import React, {Component} from 'react';
import {Button, Checkbox, DatePicker, Form, Input, Modal,} from "antd";
import {ShowErrorNotification, ShowValidationErrorNotification} from '../../../utils';
import data from '../../../data';
import moment from "moment";
import locale from 'antd/es/date-picker/locale/tr_TR';

class CreateModal extends Component {
    state = {
        loading: false,
        visible: false,
    };

    constructor(props) {
        super(props);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
    }


    showModal = () => {
        this.setState({
            loading: false,
            visible: true
        });
    };

    closeModal(record) {
        this.setState({visible: false}, () => {
            if (this.props.onClose) {
                this.props.onClose(record);
            }
        })
    };

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return ShowValidationErrorNotification();
            }
            this.setState({loading: true});
            data.createPeriod({
                ...values,
                starting_date: moment(values.starting_date).format('YYYY-MM-DD')
            })
                .then(this.closeModal)
                .catch(err => ShowErrorNotification('Yıl kaydedilemedi', err))
                .finally(() => this.setState({loading: false}));
        });
    };

    handleCancel() {
        this.closeModal();
    };

    renderForm() {
        const {getFieldDecorator} = this.props.form;
        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Item label="Ad">
                    {getFieldDecorator('name', {
                        rules: [{required: true, message: 'Yıl adı girilmemiş'}]
                    })(<Input autoFocus />)}
                </Form.Item>
                <Form.Item label="Başlangıç Tarihi">
                    {getFieldDecorator('starting_date', {
                        rules: [{required: true, message: 'Başlangıç tarihi girilmemiş'}]
                    })(<DatePicker locale={locale} format="DD/MM/YYYY" placeholder="Tarih seçin"/>)}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('enabled', {
                        initialValue: true,
                        valuePropName: 'checked',
                    })(<Checkbox>Aktif</Checkbox>)}
                </Form.Item>
            </Form>
        );
    }

    componentDidMount() {
        if (this.props.visible) {
            this.showModal();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.visible !== this.props.visible && this.props.visible) {
            this.showModal();
        }
    }

    render() {
        return (
            <Modal
                visible={this.state.visible}
                title="Yeni Yıl"
                onOk={this.handleSubmit}
                onCancel={this.handleCancel}
                footer={[
                    <Button
                        key="back"
                        onClick={this.handleCancel}>
                        Kapat
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        icon={this.state.loading ? 'loading' : 'check'}
                        onClick={this.handleSubmit}
                    >
                        Kaydet
                    </Button>
                ]}
                destroyOnClose={true}
            >
                {this.renderForm()}
            </Modal>
        );
    }
}

export default Form.create()(CreateModal);
